import { PRODUCT_CATEGORY, PRODUCT_TYPES } from '@schuettflix/interfaces';

export const productTypeToProductCategoryMap = {
    // =================================
    // Handled by custom-request-service
    // =================================
    // Materials
    CUSTOM_BULK_MATERIAL: 'MATERIAL',
    CUSTOM_RECYCLED_BULK_MATERIAL: 'MATERIAL',
    CUSTOM_CONCRETE: 'MATERIAL',
    CUSTOM_ASPHALT: 'MATERIAL',
    // Waste
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: 'MATERIAL',
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: 'MATERIAL',
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: 'MATERIAL',
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING: 'MATERIAL',
    // Transports
    CUSTOM_TRANSPORT: 'TRANSPORT',
    // Material Services
    CUSTOM_SERVICE: 'MATERIAL_SERVICE',
    CUSTOM_SERVICE_ANALYSIS: 'MATERIAL_SERVICE',
    CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT: 'MATERIAL_SERVICE',
    // Transport Services
    CUSTOM_SERVICE_TRANSPORT: 'TRANSPORT_SERVICE',
    CUSTOM_SERVICE_TOLL: 'TRANSPORT_SERVICE',
    CUSTOM_SERVICE_WAITING_TIME: 'TRANSPORT_SERVICE',
    // ===================================
    // Handled by material-channel-service
    // ===================================
    // Materials
    BULK_MATERIAL: 'MATERIAL',
    RECYCLED_BULK_MATERIAL: 'MATERIAL',
    // Waste
    HAZARDOUS_WASTE_DISPOSAL: 'MATERIAL',
    HAZARDOUS_WASTE_RECYCLING: 'MATERIAL',
    NON_HAZARDOUS_WASTE_DISPOSAL: 'MATERIAL',
    NON_HAZARDOUS_WASTE_RECYCLING: 'MATERIAL',
    // ============================
    // Handled by transport-service
    // ============================
    TRANSPORT: 'TRANSPORT',
    // ==============================
    // No channel — synthesized at fulfillment time
    // ==============================
    SERVICE_TOLL: 'TRANSPORT_SERVICE',
    SERVICE_WEIGHING_NOTE: 'TRANSPORT_SERVICE',
    SERVICE_ACCOMPANYING_DOCUMENT: 'TRANSPORT_SERVICE',
    SERVICE_ENERGY_SURCHARGE: 'TRANSPORT_SERVICE',
} as const satisfies Record<PRODUCT_TYPES, PRODUCT_CATEGORY>;
